module.exports = __webpack_public_path__ + "img/gwrraSeal@3x.dcff18ae.png";